import { useEffect } from 'react'
import { logEvent } from '@praxis/component-logging'
import { Card, Grid, Layout } from '@enterprise-ui/canvas-ui-react'
import { SectionHeader } from '../globalComponents/SectionHeader'
import { useRouteError } from 'react-router'
import apiConfig from '../globalConfig/apiConfig'

export const UncaughtError = ({ errorString }) => {
  const routeError = useRouteError()

  useEffect(() => {
    logEvent(
      {
        message: `Unknown User encountered the following error: ${routeError ? routeError?.message : errorString}`,
      },
      apiConfig?.logging,
    )
  }, [routeError, errorString])

  return (
    <>
      <SectionHeader
        className="hesp-sectionHeader-layout"
        pageHeading="Error"
      />
      <Layout.Body
        className="hesp-generic-layout"
        data-testid="layoutWithErrorContent"
        includeRail
      >
        <Card className="hc-pa-normal">
          <Grid.Container>
            <Grid.Item className="hesp-general-fullwidth">
              <p>Oops! We encountered an unexpected error.</p>
            </Grid.Item>
          </Grid.Container>
        </Card>
      </Layout.Body>
    </>
  )
}
